import { render, staticRenderFns } from "./EmailMessageReplyBox.vue?vue&type=template&id=286f96dc&scoped=true&"
import script from "./EmailMessageReplyBox.vue?vue&type=script&lang=js&"
export * from "./EmailMessageReplyBox.vue?vue&type=script&lang=js&"
import style0 from "./EmailMessageReplyBox.vue?vue&type=style&index=0&id=286f96dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f96dc",
  null
  
)

export default component.exports